const LinesAboutMe = () =>
    <p className={'text-center'}>
        A software engineer passionate about quality, fond of devops, likes to code and loves technology
    </p>;

export default LinesAboutMe;
